
import Grid from "@material-ui/core/Grid";
import Bignumber from "components/Bignumbers/Bignumber";

export default function BignumbersTitulos({ data, isMobile }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={isMobile}>
        <Bignumber
          label="Limite Adotado"
          value={data.limiteAdotado ? "R$" + data.limiteAdotado : '-'}
          icon={"ni ni-money-coins"}
        />
      </Grid>
      <Grid item xs={isMobile}>
        <Bignumber
          label="Limite Tomado"
          value={data.limiteTomado ? "R$" + data.limiteTomado : '-'}
          icon={"ni ni-money-coins"}
        />
      </Grid>
      <Grid item xs={isMobile}>
        <Bignumber
          label="Limite Disponível"
          value={data.limiteDisponivel ? "R$" + data.limiteDisponivel : '-'}
          icon={"ni ni-money-coins"}
        />
      </Grid>
    </Grid>
  );
}
